import { statusBadge } from "@/lib/data";

interface BadgeProps {
  label: string;
  status: string;
}

export default function Badge({ label, status }: BadgeProps) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium capitalize ${statusBadge(status)}`}>
      {label}
    </span>
  );
}
